module.exports = __webpack_public_path__ + "images/lime-c64d83ad.png";